import React from 'react';
import { DateInput, TextInput, EnumDropdown, ClearAfterUnmountWrapper } from 'framework/form';
import { VENDOR_DURACTION_TYPE_VALUES, AGREEMENT_TYPES, VENDOR_DURACTION_TYPE } from '../../constants';
import ConditionalWrapper from 'domain/finance/vendors/shared/components/ConditionalWrapper';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';

interface FinalizeAgreementFormProps {
  agreementType?: string;
}

const FinalizeAgreementForm = ({ agreementType }: FinalizeAgreementFormProps) => (
  <>
    <EnumDropdown label="Duration type" source="durationType" options={VENDOR_DURACTION_TYPE_VALUES} isRequired />

    <DateInput label="Start date" source="startDate" isRequired />

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.durationType !== VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" isRequired />
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.durationType === VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" />
    </ConditionalWrapper>

    <ConditionalWrapper isVisible={() => agreementType === AGREEMENT_TYPES.PUBLIC_OFFER}>
      <ClearAfterUnmountWrapper>
        <TextInput source="publicOfferLink" label="Public offer link" placeholder="Public offer link" isRequired />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>

    <ConditionalWrapper isVisible={() => agreementType === AGREEMENT_TYPES.CONTRACT}>
      <ClearAfterUnmountWrapper>
        <NoteAttachmentUploaderInput
          source="signedContractAttachment"
          label="Signed contract attachment"
          isNewDocumentStorage
          isRequired
        />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>
  </>
);

export default FinalizeAgreementForm;
